type Context = 'webhook';

type Section = 'init';

type Value = `${Context}-${Section}`;

export const Keys: Record<Section, Value> = {
  init: 'webhook-init',
};
